import { ClubHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetPotentialFacilityDupesData = (address1, city, stateCode, postalCode, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/Facility/query/dupcheck?address=${encodeURIComponent(address1)}&city=${encodeURIComponent(city)}&stateCode=${encodeURIComponent(stateCode)}&postalCode=${encodeURIComponent(postalCode)}`;
    ClubHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetPotentialFacilityDupesData;